
/* injects from baggage-loader */

export const SHOW_CONFIRM = 'SHOW_CONFIRM'
export const HIDE_CONFIRM = 'HIDE_CONFIRM'

const initialState = {
  confirmShow: false,
  confirmProps: {}
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SHOW_CONFIRM:
      return {
        confirmShow: true,
        confirmProps: action.confirmProps
      }
    case HIDE_CONFIRM:
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/ui/confirm/index.js